import {
  IGetPersonalDataPolicy,
  IGetChatBotPersonalData,
} from '@/@types/api/public';
import { http } from '@/plugins/axios';

const endPoint = '/public';

/**
 * Возвращает текст политики политики оператора в отношении
 * обработки персональных данных для интернет-сайта
 *
 * @param {String} host адрес сайта для отображения политики
 * @returns {Promise<any>}
 */
export const getPersonalDataPolicy: IGetPersonalDataPolicy = async (params) => {
  return await http.get(`${endPoint}/WebPersonalDataPolicy`, { params });
};

/**
 * Возвращает текст политики политики оператора в отношении
 * обработки персональных данных для интернет-сайта
 *
 * @param {String} host адрес сайта для отображения политики
 * @returns {Promise<any>}
 */
export const getPersonalDataAgreement: IGetPersonalDataPolicy = async (
  params,
) => {
  return await http.get(`${endPoint}/WebPersonalDataAgreement`, { params });
};

export const getChatBotPersonalDataPolicy = async ({
  base,
  bot,
}: IGetChatBotPersonalData): Promise<string> => {
  return await http.get<string>(`${endPoint}/ChatBotPersonalDataPolicy`, {
    params: { bot },
  });
};

export const getChatBotPersonalDataAgreement = async ({
  base,
  bot,
}: IGetChatBotPersonalData): Promise<string> => {
  return await http.get<string>(`${endPoint}/ChatBotPersonalDataAgreement`, {
    params: { bot },
  });
};
